"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/sort-comp */
/* eslint-disable default-param-last */
const react_1 = __importStar(require("react"));
const next_utils_monitoring_1 = require("@gerenciatd/next.utils.monitoring");
const prop_types_1 = __importDefault(require("prop-types"));
const next_utils_metrics_1 = require("@gerenciatd/next.utils.metrics");
// import { infoLog, errorLog } from '@gerencia/';
const FETCHING = 'fetching';
const SUCCESS = 'success';
const ERROR = 'error';
class TaggedComponent extends react_1.Component {
    constructor(props) {
        super(props);
        this.buildEventObj = (kind = 'print', status) => {
            const { taggingInfo, customizerId } = this.props;
            const { componentUuid } = this;
            const newEvent = `${kind}-${status}`;
            const event = Object.assign(Object.assign({}, taggingInfo), { event: 'cms-component', eventType: newEvent, componentUuid });
            event.customizerId = customizerId;
            if (status === FETCHING) {
                this.componentUuid = (0, next_utils_monitoring_1.getUUID)('', '', false);
                event.componentUuid = this.componentUuid;
            }
            if (!event.componentVariation) {
                event.componentVariation = '';
            }
            if (!event.componentContent) {
                event.componentContent = '';
            }
            if (!event.componentProduct) {
                event.componentProduct = '';
            }
            return event;
        };
        this.state = {};
        this.taggedComponentUuid = (0, next_utils_monitoring_1.getUUID)('', '', false);
        this.componentUuid = -1;
        this.errorFound = false;
    }
    componentDidMount() {
        /* tagWhenMounted BEGINS */
        const { tagWhenMounted, status } = this.props;
        if (tagWhenMounted && status) {
            const domTagged = document.getElementById(this.taggedComponentUuid);
            if (domTagged) {
                const event = this.buildEventObj('print', status);
                (0, next_utils_metrics_1.sendCMSEvent)(event, status);
            }
        }
        /* tagWhenMounted ends */
    }
    componentDidUpdate(prevProps) {
        // Envio de eventos
        const { errorFound } = this;
        const { status } = this.props;
        if (!errorFound && status === SUCCESS && prevProps.status !== SUCCESS) {
            const domTagged = document.getElementById(this.taggedComponentUuid);
            if (domTagged) {
                const event = this.buildEventObj('print', status);
                (0, next_utils_metrics_1.sendCMSEvent)(event, status);
            }
        }
        // alarmo en función de los datos obtenidos
        if (!errorFound && prevProps.status !== status && status === FETCHING) {
            const event = this.buildEventObj('print', status);
            (0, next_utils_metrics_1.sendCMSEvent)(event, status);
        }
    }
    componentDidCatch(error, info) {
        const event = this.buildEventObj('print', ERROR);
        // we must append error
        event.componentErrorDetail = error.toString();
        // errorLog(`[${id}]: ${event.componentErrorDetail}`);
        // errorLog(`[${id}-trace]: ${info}`);
        (0, next_utils_metrics_1.sendCMSEvent)(event);
        // infoLog('print-error');
        // debo monitorizar
        this.errorFound = true;
    }
    render() {
        const { errorFound } = this;
        let { visible } = this.props;
        const { children, errorComponents, status } = this.props;
        if (typeof visible === 'string') {
            visible = visible.toLowerCase() === 'true';
        }
        const { CompileError, NetworkError } = errorComponents;
        if (errorFound) {
            return react_1.default.createElement(CompileError, null);
        }
        if (status && status === ERROR && NetworkError) {
            return react_1.default.createElement(NetworkError, null);
        }
        if (status && status === FETCHING) {
            return (react_1.default.createElement("div", { style: {
                    height: '450px',
                    width: '100%',
                    backgroundColor: 'lightgray',
                } }));
            // return <WaitingComponent />;
        }
        // eslint-disable-next-line eqeqeq
        if (visible == true && status && status === SUCCESS) {
            return react_1.default.createElement("div", { id: this.taggedComponentUuid }, children);
        }
        return (react_1.default.createElement("div", { style: { height: '450px', width: '100%', backgroundColor: 'lightgray' } }));
    }
}
TaggedComponent.propTypes = {
    id: prop_types_1.default.string.isRequired,
    /**
     * {
     *  "info": "Indica creatividad de custo que se pretende taguear",
     *  "kind": "playground",
     *  "beautifulName": "Idcreatividad custo"
     * }
     */
    customizerId: prop_types_1.default.string,
    visible: prop_types_1.default.oneOfType([prop_types_1.default.bool, prop_types_1.default.string]),
    /**
     * {
     *  "info": "Define el componente que se devolverá en caso de exito en el taggeo",
     *  "kind": "playground",
     *  "beautifulName": "Componente para exito"
     * }
     */
    children: prop_types_1.default.node.isRequired,
    /**
     * {
     *  "info": "Define el componente que se devolverá para la espera mientras se realiza el taggeo",
     *  "kind": "playground",
     *  "beautifulName": "Componente espera"
     * }
     */
    WaitingComponent: prop_types_1.default.func,
    /**
     * {
     *  "info": "Define el componente que se devolverán en caso de error durante el taggeo; dos tipos: CompileError y NetworkError",
     *  "kind": "playground",
     *  "beautifulName": "Componentes para error"
     * }
     */
    errorComponents: prop_types_1.default.shape({
        /**
         * {
         *  "info": "Define el componente que se devolverá en caso de error de compilación en el taggeo",
         *  "kind": "playground",
         *  "beautifulName": "Error de compilación "
         * }
         */
        CompileError: prop_types_1.default.func,
        /**
         * {
         *  "info": "Define el componente que se devolverá en caso de error de red en el taggeo",
         *  "kind": "playground",
         *  "beautifulName": "Error de red"
         * }
         */
        NetworkError: prop_types_1.default.func,
    }),
    /**
     * {
     *  "info": "Envía un evento al montarse el componente, útil para situaciones en las que solo se quiere alarmar una aparición sin petición, status debe de ser diferente de null",
     *  "kind": "both",
     *  "beautifulName": "Tageo tras render"
     * }
     */
    tagWhenMounted: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Establece los diferentes estados que pueden haber durante el taggeo, es importante que si es secuencia comience desde null, hasta succes ó error",
     *  "kind": "both",
     *  "beautifulName": "Estado de taggeo"
     * }
     */
    status: prop_types_1.default.oneOf([null, SUCCESS, FETCHING, ERROR]),
    /**
     * {
     *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
     *  "kind": "both",
     *  "beautifulName": "Propiedades tagueo"
     * }
     */
    taggingInfo: prop_types_1.default.object,
};
TaggedComponent.defaultProps = {
    customizerId: '',
    visible: true,
    WaitingComponent: () => null,
    errorComponents: {
        CompileError: () => null,
        NetworkError: () => null,
    },
    tagWhenMounted: false,
    status: null,
    taggingInfo: null,
};
exports.default = TaggedComponent;
//# sourceMappingURL=index.js.map